import React from "react";


const PATHS = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7" height="8" rx="1.5"/>
      <rect x="14" y="3" width="7" height="5" rx="1.5"/>
      <rect x="14" y="11" width="7" height="10" rx="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5"/>
    </>
  ),
  chart: (
    <>
      <path d="M3.5 20.5V13"/>
      <path d="M9 20.5V6.5"/>
      <path d="M14.5 20.5v-5"/>
      <path d="M20 20.5V9.5"/>
    </>
  ),
  forms: (
    <>
      <path d="M6.5 3.5h11a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5a1.5 1.5 0 0 1 1.5-1.5z"/>
      <path d="M8.5 8h7M8.5 12h7M8.5 16h4"/>
    </>
  ),
  rupee2: (
    <>
      <path d="M7 4.5h10"/>
      <path d="M7 9h10"/>
      <path d="M7 4.5c5 0 7.5 1.2 7.5 4.5S12 13.5 7 13.5l8 6"/>
    </>
  ),
  cart: (
    <>
      <circle cx="9.5" cy="20" r="1.4"/>
      <circle cx="18" cy="20" r="1.4"/>
      <path d="M2.5 3.5h2.6l2.6 11.4h11l2.3-8.4H6.4"/>
    </>
  ),
  package: (
    <>
      <path d="M3.2 7.6L12 3.3l8.8 4.3v8.8L12 20.7l-8.8-4.3z"/>
      <path d="M3.2 7.6L12 12l8.8-4.4"/>
      <path d="M12 12v8.7"/>
    </>
  ),
  boxout: (
    <>
      <path d="M3.5 8.2l8.5-4.4 8.5 4.4v7.6L12 20.2l-8.5-4.4z"/>
      <path d="M12 11.4v8.8"/>
      <path d="M3.5 8.2L12 12.6l8.5-4.4"/>
      <path d="M15.5 5.2L7.5 9.4"/>
    </>
  ),
  stock: (
    <>
      <path d="M3 7.6l9-4.2 9 4.2v8.8l-9 4.2-9-4.2z"/>
      <path d="M3 7.6l9 4.2 9-4.2"/>
      <path d="M12 11.8v8.8"/>
    </>
  ),

  clipcheck: (
    <>
      <rect x="4.5" y="4.6" width="15" height="15.9" rx="2"/>
      <path d="M9 4.6v-.9A1.2 1.2 0 0 1 10.2 2.5h3.6A1.2 1.2 0 0 1 15 3.7v.9z"/>
      <path d="M8.6 12.4l2.4 2.4 4.6-5"/>
    </>
  ),
  truck: (
    <>
      <rect x="2.5" y="6.4" width="10.7" height="9.5" rx="1.4"/>
      <path d="M13.2 10h3.4l4 3.4v2.5h-7.4z"/>
      <circle cx="7" cy="18.4" r="1.9"/>
      <circle cx="17.2" cy="18.4" r="1.9"/>
      <path d="M2.5 15.9h2.6M8.9 15.9h6.4"/>
    </>
  ),
  parcelback: (
    <>
      <rect x="9" y="6.8" width="12" height="11.4" rx="1.8"/>
      <path d="M9 11.4h12"/>
      <path d="M15 6.8v4.6"/>
      <path d="M6.4 12.5H2.3"/>
      <path d="M4.8 9.9L2.2 12.5l2.6 2.6"/>
    </>
  ),
  sliders: (
    <>
      <path d="M4 7h9M17 7h3"/>
      <path d="M4 17h3M11 17h9"/>
      <circle cx="15" cy="7" r="2.2"/>
      <circle cx="9" cy="17" r="2.2"/>
    </>
  ),
  users: (
    <>
      <circle cx="8.5" cy="8" r="3"/>
      <path d="M3 19a5.5 5.5 0 0 1 11 0"/>
      <circle cx="17" cy="9.5" r="2.4"/>
      <path d="M15 19a4.4 4.4 0 0 1 6.4-3.9"/>
    </>
  ),
  pill: (
    <>
      <rect x="2.6" y="7.6" width="18.8" height="8.8" rx="4.4" transform="rotate(-40 12 12)"/>
      <path d="M9.2 8.7l5.6 6.6"/>
    </>
  ),
  undo: (
    <>
      <path d="M3.5 8.5h11a5.5 5.5 0 0 1 0 11H8"/>
      <path d="M7 4.2L3.2 8.5 7 12.8"/>
    </>
  ),
  billing: (
    <>
      <path d="M6 3h12a1 1 0 0 1 1 1v17l-3-1.6-3 1.6-3-1.6L7 21H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/>
      <path d="M9 8h6M9 12h6"/>
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.6"/>
      <path d="M12 7.3V12l3 1.8"/>
    </>
  ),
  partner: (
    <>
      <rect x="2.5" y="7" width="19" height="13.5" rx="2.4"/>
      <path d="M8.75 7V5.5A1.5 1.5 0 0 1 10.25 4h3.5a1.5 1.5 0 0 1 1.5 1.5V7"/>
      <path d="M12 11.5v5M9.5 14h5"/>
    </>
  ),
  plus: (
    <>
      <path d="M12 5v14M5 12h14"/>
    </>
  ),
  upload: (
    <>
      <path d="M12 20V9"/>
      <path d="M7.6 13.1L12 8.7l4.4 4.4"/>
      <path d="M4.5 4.5h15"/>
    </>
  ),
  close: (
    <>
      <path d="M6 6l12 12"/>
      <path d="M18 6L6 18"/>
    </>
  ),
  chev: (
    <>
      <path d="M6 9.5l6 6 6-6"/>
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.8"/>
      <path d="M20 20l-4.1-4.1"/>
    </>
  ),
  download: (
    <>
      <path d="M12 3.5v11"/>
      <path d="M7.6 10.4L12 14.8l4.4-4.4"/>
      <path d="M4.5 19.5h15"/>
    </>
  ),
  check: (
    <>
      <path d="M4.5 12.5l5 5 10-10"/>
    </>
  ),
  trash: (
    <>
      <path d="M4.5 6.5h15"/>
      <path d="M9.5 6.5V5a1.5 1.5 0 0 1 1.5-1.5h2A1.5 1.5 0 0 1 14.5 5v1.5"/>
      <path d="M6.5 6.5l.8 12A1.6 1.6 0 0 0 8.9 20h6.2a1.6 1.6 0 0 0 1.6-1.5l.8-12"/>
    </>
  ),
  edit: (
    <>
      <path d="M4 20.5h4L18.6 9.9a2.2 2.2 0 0 0-3.1-3.1L4.9 17.4v3.1z"/>
      <path d="M14.2 8.2l3.1 3.1"/>
    </>
  ),
  bed: (
    <>
      <path d="M2.5 20V7"/>
      <path d="M2.5 14.5h15a4 4 0 0 1 4 4V20"/>
      <path d="M2.5 20h19"/>
      <rect x="5.5" y="10.5" width="5" height="4" rx="1.2"/>
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.6"/>
      <path d="M12 11v5.2M12 7.9v.2"/>
    </>
  ),
  print: (
    <>
      <path d="M7 8.5V3.5h10v5"/>
      <rect x="3.5" y="8.5" width="17" height="7.5" rx="1.8"/>
      <path d="M7 14h10v6.5H7z"/>
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5.5" r="2.6"/>
      <circle cx="6" cy="12" r="2.6"/>
      <circle cx="18" cy="18.5" r="2.6"/>
      <path d="M8.3 10.8l7.4-3.9M8.3 13.2l7.4 3.9"/>
    </>
  ),
  filter: (
    <>
      <path d="M3.5 5.5h17l-6.6 7.6v5.3l-3.8 2.1v-7.4z"/>
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.7 21a2 2 0 0 1-3.4 0"/>
    </>
  ),
  back: (
    <>
      <path d="M15 5l-7 7 7 7"/>
    </>
  ),
  /* A bill with a way out of it - "open the bill this came off". */
  /* A chevron pointing right, which the fold turns down - distinct from
     `chev`, which already points down. */
  chevRight: (
    <>
      <path d="M9 6l6 6-6 6"/>
    </>
  ),
  swap: (
    <>
      <path d="M7 7h12l-3-3M17 17H5l3 3"/>
    </>
  ),
  billgo: (
    <>
      <path d="M5 3h8a1 1 0 0 1 1 1v16l-2.4-1.5L9.2 20l-2.4-1.5L4.4 20V4a1 1 0 0 1 .6-1z"/>
      <path d="M7.4 8h4M7.4 11.5h4"/>
      <path d="M15.5 8.5 21 3"/>
      <path d="M16.9 3H21v4.1"/>
    </>
  ),
  bolt: (
    <>
      <path d="M13.2 2.8L5 13.4h5.6l-.8 7.8L18 10.6h-5.6z"/>
    </>
  ),
  eye: (
    <>
      <path d="M2.2 12S5.8 5.4 12 5.4 21.8 12 21.8 12 18.2 18.6 12 18.6 2.2 12 2.2 12z"/>
      <circle cx="12" cy="12" r="3.1"/>
    </>
  ),
  /* ---- the report glyphs, drawn as the mockup draws them ---------------- */
  coins: (
    <>
      <ellipse cx="12" cy="6.4" rx="7.5" ry="3"/>
      <path d="M4.5 6.4v5.2c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3V6.4"/>
      <path d="M4.5 11.6v5.2c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3v-5.2"/>
    </>
  ),
  ledger: (
    <>
      <path d="M4.2 5.2A1.7 1.7 0 0 1 5.9 3.5H19.3v17H5.9a1.7 1.7 0 0 1-1.7-1.7z"/>
      <path d="M4.2 17h15.1"/>
      <path d="M8 7.6h7.4M8 11.2h7.4"/>
    </>
  ),
  services: (
    <>
      <path d="M12 3l8.5 4.5L12 12 3.5 7.5 12 3z"/>
      <path d="M3.5 12L12 16.5 20.5 12"/>
      <path d="M3.5 16.5L12 21l8.5-4.5"/>
    </>
  ),
  storefront: (
    <>
      <path d="M3.6 9.8V20.5h16.8V9.8"/>
      <path d="M2.5 9.8l2-6h15l2 6z"/>
      <path d="M7 9.8a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0"/>
      <path d="M9.6 20.5v-5.8h4.8v5.8"/>
    </>
  ),
  percent: (
    <>
      <path d="M18.6 5.4L5.4 18.6"/>
      <circle cx="7.4" cy="7.4" r="2.8"/>
      <circle cx="16.6" cy="16.6" r="2.8"/>
    </>
  ),
  /* Not one of the mockup's own - the module needs a "this line needs looking
     at" mark for a medicine the pharmacy cannot supply. Drawn in the same hand
     as the rest: one stroke, the same 24-box, the same weight. */
  alert: (
    <>
      <path d="M12 3.6L21.2 19.5a1.4 1.4 0 0 1-1.2 2.1H4a1.4 1.4 0 0 1-1.2-2.1z"/>
      <path d="M12 9.6v4.6M12 17.4v.2"/>
    </>
  ),
  building: (
    <>
      <path d="M3 21h18"/>
      <path d="M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16"/>
      <path d="M15 21V11h2a2 2 0 0 1 2 2v8"/>
      <path d="M9 7h2M9 11h2M9 15h2"/>
    </>
  ),
};

const CgIcon = ({ name, size = 19, stroke = 1.85, ...rest }) => {
  const paths = PATHS[name];
  if (!paths) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {paths}
    </svg>
  );
};

export const ICON_NAMES = Object.keys(PATHS);

export default CgIcon;
